/**
 * Copyright ©2025 Drivepoint
 */

export class EventStreamerEvent extends Event {
  constructor(type: string, public value: any) {
    super(type);
  }
}

export default class EventStreamer extends EventTarget {

  constructor(private _reader: ReadableStreamDefaultReader) {
    super();
    this._process();
  }

  async stop(): Promise<void> {
    return this._reader.cancel();
  }

  public get reader(): ReadableStreamDefaultReader {
    return this._reader;
  }

  private async _process(): Promise<void> {
    try {
      let buffer = "";
      const decoder = new TextDecoder();
      while (true) {
        const {done, value} = await this._reader.read();
        if (done) { break; }
        buffer += decoder.decode(value);
        while (buffer.includes("\n\n")) {
          const eventEnd = buffer.indexOf("\n\n");
          const eventText = buffer.slice(0, eventEnd);
          buffer = buffer.slice(eventEnd + 2);
          const lines = eventText.split("\n");
          let type = "message";
          let data = "";
          for (const line of lines) {
            if (line.startsWith("event:")) {
              type = line.slice(6).trim();
            } else if (line.startsWith("data:")) {
              data = line.slice(5).trim();
            }
          }
          this.dispatchEvent(new EventStreamerEvent(type, JSON.parse(data)));
        }
      }
    } catch (error: any) {
      logger.error(error.message);
      this.dispatchEvent(new EventStreamerEvent("error", error));
    }
  }

}
